import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  emptyMessage: "No Language References Found",
  fields: [
    {
      attributeName: 'locale',
      label: 'Language',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Locale code (e.g. en-US)',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'appName',
      label: 'App Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Application name',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'configName',
      label: 'App Config Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Configuration name',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'configurationLink',
      label: 'Link to Configuration',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      helpText: 'Link to the configuration',
      canOrder: false,
      canFilter: false,
    }
  ],
};